module.exports = __webpack_public_path__ + "img/icon-512.a561ebd7.png";